import {
  Directive,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { AlertController, AlertOptions } from '@ionic/angular';
import {
  BackgroundColor,
  InAppBrowser,
  ToolBarType
} from '@capgo/inappbrowser';

import {
  HelpdeskService,
  HelpdeskTopic
} from '@smartcharge/shared/features/helpdesk';
import { Capacitor } from '@capacitor/core';
import { AppLauncher } from '@capacitor/app-launcher';

@Directive({
  selector: '[scHelpdeskButton]',
  standalone: false
})
export class HelpdeskButtonDirective implements OnChanges {
  @Input() feedbackAlert?: AlertOptions;
  @Input() topic: HelpdeskTopic;

  protected link: string;

  @HostBinding('class.hidden')
  hasNoLink(): boolean {
    return !this.link && !this.feedbackAlert;
  }

  constructor(
    private alertCtrl: AlertController,
    private helpdeskService: HelpdeskService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('topic' in changes) {
      this.getLink();
    }
  }

  @HostListener('click')
  async openLink(): Promise<void> {
    if (this.link) {
      if (Capacitor.isNativePlatform()) {
        InAppBrowser.openWebView({
          url: this.link,
          toolbarType: ToolBarType.ACTIVITY,
          title: '',
          backgroundColor: BackgroundColor.WHITE
        });
      } else {
        AppLauncher.openUrl({ url: this.link });
      }
    } else if (this.feedbackAlert) {
      const alert = await this.alertCtrl.create(this.feedbackAlert);
      alert.present();
    }
  }

  private getLink(): void {
    this.helpdeskService
      .getHelpdeskURL(this.topic)
      .subscribe((link: string) => {
        this.link = link;
      });
  }
}
